// Webpack Imports
import * as bootstrap from 'bootstrap';
import './components/_header';
import './components/_footer';
import './components/_menu-vous-etes';
import './components/_home-alaune';
import './components/_faq';
import './components/_vos-demarches';
import './components/_page_menu';

( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();npm
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );

	// Setting min height for main container
	var footerContainerHeight =  document.getElementById('footer').offsetHeight;
	document.getElementById('main').style.minHeight = window.innerHeight - footerContainerHeight + 'px';
	// End Setting min height for main container

	console.Log('coucou');

} )();